// export const baseUrl = "https://stemey-control.eduplj.com/api";
export const baseUrl ="https://plj-stem-ey.discoveryeducationme.com/api"

export const endpoints = {
  googleAuth: "/auth/google_oauth",
  parent: "/parent/index",
};
